import { styled } from "@mui/material/styles";
import { Paper, Box, FormLabel, FormControlLabel } from "@mui/material";

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: "#f8f9fa",
  borderRadius: theme.spacing(1.5),
  border: "1px solid #e9ecef",
  height: "100%",
}));

export const HeaderBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const AccentLine = styled(Box)(({ theme }) => ({
  width: "60px",
  height: "4px",
  backgroundColor: theme.palette.primary.main,
  borderRadius: "2px",
  marginTop: theme.spacing(1),
}));

export const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
}));

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    fontSize: "13px",
    color: theme.palette.text.secondary,
  },
  margin: theme.spacing(0.5, 0),
}));

export const ActionBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: theme.spacing(2),
  marginTop: theme.spacing(4),
}));
